import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Video, PhoneMissed, PhoneIncoming, PhoneOutgoing } from "lucide-react";
import { api } from "@/lib/api";
import { useTalk, TkAvatar, tkErr } from "./TalkLayout";
import { ago } from "./TalkChats";

export default function TalkCalls() {
  const { engine, subscribe } = useTalk();
  const [calls, setCalls] = useState(null);
  const nav = useNavigate();
  const load = () => api.get("/talk/calls").then((r) => setCalls(r.data.calls)).catch(() => setCalls([]));
  useEffect(() => { load(); }, []);
  useEffect(() => subscribe((t) => { if (t === "call" ) setTimeout(load, 800); }), [subscribe]);
  const openChat = async (uid) => { try { const { data } = await api.post("/talk/chats", { user_id: uid }); nav(`/talk/c/${data.chat.id}`); } catch (e) { tkErr(e); } };
  return (
    <div data-testid="talk-calls">
      <h1 className="font-heading font-black text-4xl mb-5">Calls</h1>
      {calls === null ? <div className="text-white/40 animate-pulse text-sm">Loading…</div> : !calls.length ? (
        <div className="py-14 text-center text-white/50 text-sm" data-testid="talk-calls-empty">No calls yet. Open a chat and tap the phone or camera to call.</div>
      ) : calls.map((c) => {
        const missed = c.status !== "completed";
        const Icon = missed && c.direction === "in" ? PhoneMissed : c.direction === "in" ? PhoneIncoming : PhoneOutgoing;
        return (
          <div key={c.id} className="flex items-center gap-3 p-3 rounded-2xl hover:bg-white/[0.04]" data-testid={`talk-call-row-${c.id}`}>
            <button onClick={() => c.other && openChat(c.other.user_id)}><TkAvatar p={c.other || { display_name: c.group_name || "G" }} size={46} /></button>
            <div className="flex-1 min-w-0">
              <div className={`font-bold truncate ${missed && c.direction === "in" ? "text-[#FF6A6A]" : ""}`}>{c.other?.display_name || (c.group ? `${c.group_name} · group` : "Member")}</div>
              <div className="text-xs text-white/50 flex items-center gap-1"><Icon className="w-3.5 h-3.5" />{c.video ? "Video" : "Voice"} · {c.status === "completed" ? `${Math.floor(c.duration / 60)}m ${c.duration % 60}s` : c.status} · {ago(c.created_at)}</div>
            </div>
            {c.other && <>
              <button onClick={() => engine?.startCall(c.other, false)} data-testid={`talk-call-again-voice-${c.id}`} aria-label="Voice call" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center"><Phone className="w-4 h-4" /></button>
              <button onClick={() => engine?.startCall(c.other, true)} data-testid={`talk-call-again-video-${c.id}`} aria-label="Video call" className="w-10 h-10 rounded-full bg-[#00F0FF]/15 text-[#00F0FF] flex items-center justify-center"><Video className="w-4 h-4" /></button>
            </>}
          </div>
        );
      })}
    </div>
  );
}
